import {Picture} from "../../model/picture";

export class Image {

    src: string;
    msrc: string;
    w: number;
    h: number;

    constructor(picture?: Picture) {

        if(picture!=null) {
            this.src = picture.url;
            this.msrc = picture.miniatureUrl;
            this.h = picture.height;
            this.w = picture.width;
        }
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/photoswipe/image.model.ts